export const USER_METADATA_EDITOR = 'MetadataEditor';
export const USER_UNCATEGORIZED_VIEWER = 'UncategorizedViewer';
export const USER_PRODUCT_EDITOR = 'ProductEditor';
export const USER_CUSTOMER_DATA = 'MerchantCustomerDataViewer';
